<template>
	<div
		class="flex h-full w-full flex-wrap overflow-hidden rounded bg-white outline outline-2 outline-transparent transition-all duration-500 ease-in-out hover:shadow-lg hover:shadow-gray-300 hover:outline-blue-400"
	>
		<CarbarLink :to="product.view.used" :underline="false" class="w-full">
			<div class="relative w-full">
				<div class="absolute left-2 top-2 z-10">
					<CarbarTags :product="product" :page-type="'used'" />
				</div>
				<FilterCardImage
					:show-slide-arrows="showSlideArrows"
					:product="product"
				/>
			</div>

			<div class="flex w-full cursor-pointer flex-wrap">
				<div class="flex w-full justify-between px-3 py-3 text-left">
					<div class="flex w-full flex-col">
						<h3 class="mb-0 h-6 items-center truncate font-bold">
							{{ product.year }} {{ product.make }}
							{{ product.model }}
						</h3>
						<div
							class="flex h-6 items-center space-x-3 text-xsm leading-none text-gray-650"
						>
							<span v-if="product.badge">
								{{ product.badge }}
							</span>
						</div>
						<div
							class="flex h-6 items-center space-x-3 text-xsm leading-none text-gray-650"
						>
							<span
								v-if="
									product.transmission ||
									product.transmission_type
								"
								v-tippy="{ placement: 'top' }"
								content="Transmission"
							>
								{{
									product.transmission_type ??
									(`${product.transmission}`
										.toLowerCase()
										.includes('manual')
										? 'Manual'
										: 'Automatic')
								}}
							</span>
							<span
								v-if="product.body_type"
								v-tippy="{ placement: 'top' }"
								content="Body type"
							>
								{{ product.body_type }}
							</span>
							<span
								v-if="product.fuel_type || product.fuel"
								v-tippy="{ placement: 'top' }"
								content="Fuel type"
							>
								{{ product.fuel ?? product.fuel_type }}
							</span>
							<span
								v-if="product.odometer"
								v-tippy="{ placement: 'top' }"
								content="Odometer"
							>
								{{ formatOdometer(product.odometer) }}km
							</span>
						</div>
						<div class="relative">
							<div
								v-if="product.location"
								v-tippy="{ placement: 'top' }"
								class="inline-flex h-6 items-center space-x-1 text-xsm text-gray-650"
								content="Location"
							>
								<IconLocation class="text-gray-650" />
								<span class="uppercase leading-none">
									{{ formatLocation(product.location) }}
								</span>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="flex w-full border-t px-3 py-3">
				<div class="flex w-full justify-between">
					<div class="flex flex-col justify-center">
						<div class="flex gap-x-1">
							<p
								class="m-0 font-heading text-2xl font-bold leading-none text-heading"
							>
								{{
									formatCurrency(
										product.retail.pricing
											.show_drive_away_price
											? product.retail.pricing
													.price_inc_drive_away
											: product.retail.pricing
													.price_ex_drive_away
									)
								}}*
							</p>
							<span class="pt-[0.4rem] text-xsm text-gray-650">
								{{
									product.retail.pricing.show_drive_away_price
										? 'Drive Away'
										: 'Excl. Govt Charges'
								}}
							</span>
						</div>
					</div>
				</div>
			</div>
		</CarbarLink>
		<CarClarityModal
			v-if="includeCarClarity"
			class="m-3 flex w-full"
			:loan-details="product.loan"
		/>
	</div>
</template>

<script setup>
import CarbarTags from '@/components/badges/CarbarTags.vue'
import CarbarLink from '@/components/links/CarbarLink.vue'
import CarClarityModal from '@/components/car-clarity/CarClarityModal.vue'
import FilterCardImage from '@/components/product-catalog/cards/FilterCardImage.vue'
import IconLocation from '@/assets/svg/common/ico-location.svg'

const props = defineProps({
	product: {
		type: Object,
		required: false,
	},
	showSlideArrows: {
		type: Boolean,
		required: false,
		default: false,
	},
	includeCarClarity: {
		type: Boolean,
		required: false,
		default: true,
	},
})
</script>
